import React from 'react';
import { Helmet } from 'react-helmet-async';
import TopNavbar from '@/components/layout/TopNavbar';
import Footer from '@/components/home/Footer';
import HiveShareHeroSection from '@/components/hiveshare-landing/HeroSection';
import PainPointsSection from '@/components/hiveshare-landing/PainPointsSection';
import DemoSection from '@/components/hiveshare-landing/DemoSection';
import HowItWorksSection from '@/components/hiveshare-landing/HowItWorksSection';
import ComparisonTable from '@/components/hiveshare-landing/ComparisonTable';
import PricingSection from '@/components/hiveshare-landing/PricingSection';
import FAQSection from '@/components/hiveshare-landing/FAQSection';
import CTASection from '@/components/hiveshare-landing/CTASection';

const HiveShareLanding = () => {
  return (
    <div className="min-h-screen bg-white relative">
      <Helmet>
        <title>HiveShare - Share Class Videos Instantly with Parents | Secure Video Platform</title>
        <meta name="description" content="Secure video sharing for activity centers. Upload class videos, assign to families, parents get instant access. No ads, no tech headaches. $29/mo early bird pricing." />
        <meta name="keywords" content="class video sharing, activity center software, secure video platform, parent communication, dance studio videos, sports class videos, lesson recordings" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://hivetivity.com/hiveshare" />
        <meta property="og:title" content="HiveShare - Share Class Videos Instantly with Parents" />
        <meta property="og:description" content="Secure video sharing for activity centers. Upload class videos, assign to families, parents get instant access. No ads, no tech headaches." />
        <meta property="og:image" content="https://media.hivetivity.com/hiveshare-landing-preview.png" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://hivetivity.com/hiveshare" />
        <meta property="twitter:title" content="HiveShare - Share Class Videos Instantly with Parents" />
        <meta property="twitter:description" content="Secure video sharing for activity centers. Upload class videos, assign to families, parents get instant access." />
        <meta property="twitter:image" content="https://media.hivetivity.com/hiveshare-landing-preview.png" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://hivetivity.com/hiveshare" />

        {/* Structured Data for SaaS Product */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "HiveShare",
            "description": "Secure video sharing platform for activity centers and sports programs",
            "url": "https://hivetivity.com/hiveshare",
            "applicationCategory": "BusinessApplication",
            "operatingSystem": "iOS, Web",
            "offers": {
              "@type": "Offer",
              "price": "29",
              "priceCurrency": "USD",
              "priceValidUntil": "2025-12-31"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Hivetivity"
            }
          }
        `}</script>
      </Helmet>

      {/* Sticky Header */}
      <TopNavbar />

      {/* Main Content */}
      <main>
        <HiveShareHeroSection />
        <PainPointsSection />
        <DemoSection />
        <HowItWorksSection />
        <ComparisonTable />
        <PricingSection />
        <FAQSection />
        <CTASection />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HiveShareLanding;